import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faPenRuler,
  faGears,
  faChartMixedUpCircleDollar,
  faPersonDigging,
  faUserHelmetSafety,
  faClock,
  faMagnifyingGlassChart,
  faFileInvoiceDollar,
  faCircleQuestion,
  faCalendarCheck
} from '@fortawesome/pro-duotone-svg-icons'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import { green } from "@ant-design/colors"

type Props = {
  section: string
  checked?: boolean
  size?: 'normal' | 'small'
}

const iconStyle: React.CSSProperties = {
  fontSize: '32pt',
  position: 'relative',
  marginRight: '10px'
}

const smallIconStyle: React.CSSProperties = {
  fontSize: '18pt'
}

const checkStyle: React.CSSProperties = {
  position: 'absolute',
  right: -12,
  bottom: -8,
  color: green.primary,
  fontSize: '24px',
  backgroundColor: 'white',
  borderRadius: '50%',
  width: '28px',
  height: '28px',
  textAlign: 'center',
  lineHeight: '28px'
}

const getSectionIcon = (section: string) => {
  switch (section) {
    case 'kickoff-call': return faCalendarCheck
    case 'system-setup': return faGears
    case 'budget': return faChartMixedUpCircleDollar
    case 'sold-jobs': return faPersonDigging
    case 'estimates': return faPenRuler
    case 'train-crew': return faUserHelmetSafety
    case 'track-time': return faClock
    case 'job-costing': return faMagnifyingGlassChart
    case 'invoicing': return faFileInvoiceDollar
    default: return faCircleQuestion
  }
}

const SectionIcon = ({section, checked, size = 'normal'}: Props) => {
  return <span style={size === 'small' ? smallIconStyle : iconStyle}>
    <FontAwesomeIcon icon={getSectionIcon(section)} />
    {checked && <div style={checkStyle}>
      <FontAwesomeIcon icon={faCircleCheck} />
    </div>}
  </span>
}

export default SectionIcon